import React, { Fragment } from "react"
import { Link } from "react-router"
import logoWhite from "assets/images/stacker-logo-white.png"

import HeaderItem from "ui/components/HeaderItem"

import {
    Logo,
    Page,
    Main,
    ClearHeader,
    ContentWrapper,
    Content,
} from "../ui/Layout"
import { Text, SectionHeader, Card, Container, Section, Button, Heading, Icon } from "ui"
import PageTitle from "ui/components/PageTitle"
import templates from "../utils/templates"
import UseTemplateButton from "../components/UseTemplateButton";


export default class TemplateListPage extends React.Component {
    render() {
        return (
            <Page>
                <ClearHeader>
                    <Link to="/"><Logo src={logoWhite} alt="Stacker Logo" /></Link>
                    <HeaderItem align="right">
                        <Link to="/logout">Logout</Link>
                    </HeaderItem>
                </ClearHeader>
                <Main>
                    <ContentWrapper>
                        <Content>
                            <PageTitle>Templates</PageTitle>
                            <Text size="fontL" padding="none" margin="none">
                                Jump start your creation on Stacker with one of our fully customisable templates. Select from the library below.
                            </Text>
                            {templates.map(template =>
                                <Fragment>
                                    <SectionHeader style={{ marginTop: 20 }}>{template.name}</SectionHeader>
                                    <Container>
                                        <img src={template.image} style={{ width: 250, float: "right", marginRight: 30, marginTop: 15, }} />
                                        <Card style={{
                                            marginTop: 10, marginBottom: 30, width: "100%"
                                        }}>
                                            < Text > <div dangerouslySetInnerHTML={{ __html: template.description }} />
                                                Contains: {template.blocks} Blocks, {template.pages} Pages, {template.tables} Tables</Text>
                                            <UseTemplateButton templateName={template.name} templateURL={template.baseURL} />
                                        </Card>
                                    </Container>
                                </Fragment>
                            )}
                        </Content>
                    </ContentWrapper>
                </Main>
            </Page>
        )
    }
}


// WEBPACK FOOTER //
// ./src/features/studio/containers/TemplateListPage.js